<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item :label="$tt('产品型号')"><a-input v-model="query.productModel" allow-clear /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="$tt('供应商')"><a-select v-model="query.vendorId" allow-clear><a-select-option value="hongxi">hongxi</a-select-option><a-select-option value="hcm111z">hcm111z</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item :label="$tt('版本')"><a-input v-model="query.versionName" allow-clear /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-button type="primary" @click="load"><a-icon type="search" />{{ $tt('查询') }}</a-button><a-button style="margin-left:8px" @click="reset">{{ $tt('重置') }}</a-button></a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" v-hasPermi="['cio:firmware:add']" @click="openForm()"><a-icon type="plus" />{{ $tt('上传固件') }}</a-button>
        <a-button type="danger" :disabled="!selected.length" v-hasPermi="['cio:firmware:remove']" @click="remove()"><a-icon type="delete" />{{ $tt('删除') }}</a-button>
      </div>
      <a-table
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data-source="rows"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selected, onChange: keys => selected = keys }">
        <template slot="published" slot-scope="value"><a-tag :color="value ? 'green' : undefined" :style="value ? undefined : { color: '#000' }">{{ value ? $tt('已发布') : $tt('草稿') }}</a-tag></template>
        <template slot="whitelist" slot-scope="value, record"><a-tag :color="value ? 'orange' : 'green'">{{ value ? $tt('白名单（{p0}人）', { p0: (record.whitelistUsers || []).length }) : $tt('所有用户') }}</a-tag></template>
        <template slot="fileSize" slot-scope="value">{{ formatSize(value) }}</template>
        <template slot="fileUrl" slot-scope="value"><a :href="resolveFirmwareUrl(value)" target="_blank" rel="noopener noreferrer" download>{{ $tt('下载') }}</a></template>
        <template slot="operation" slot-scope="text, record"><a v-hasPermi="['cio:firmware:edit']" @click="openForm(record)">{{ $tt('编辑') }}</a><a-divider type="vertical" /><a-popconfirm :title="$tt('确认删除该固件？')" @confirm="remove(record.id)"><a v-hasPermi="['cio:firmware:remove']">{{ $tt('删除') }}</a></a-popconfirm></template>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        :current="query.pageNum"
        :page-size="query.pageSize"
        :total="total"
        @change="pageChange"
        @showSizeChange="pageChange" />

      <a-drawer :title="form.id ? $tt('编辑固件') : $tt('上传固件')" width="520" :visible="formVisible" @close="formVisible=false">
        <a-form-model ref="firmwareForm" :model="form" :rules="rules" :label-col="{span:6}" :wrapper-col="{span:18}">
          <a-form-model-item :label="$tt('产品型号')" prop="productModel"><a-select v-model="form.productModel" :placeholder="$tt('请选择产品型号')"><a-select-option value="NovaPort_DUOIII65W2C">NovaPort_DUOIII65W2C</a-select-option></a-select></a-form-model-item>
          <a-form-model-item :label="$tt('供应商')" prop="vendorId"><a-select v-model="form.vendorId"><a-select-option value="hongxi">hongxi</a-select-option><a-select-option value="hcm111z">hcm111z</a-select-option></a-select></a-form-model-item>
          <a-form-model-item :label="$tt('版本名称')" prop="versionName"><a-input v-model="form.versionName" :placeholder="$tt('填写设备版本号，例如 3809331980')" /></a-form-model-item>
          <a-form-model-item :label="$tt('版本号')" prop="versionCode"><a-input-number v-model="form.versionCode" :min="0" :precision="0" style="width:100%" /></a-form-model-item>
          <a-form-model-item :label="$tt('固件文件')" prop="fileUrl">
            <a-upload
              :action="uploadUrl"
              :headers="headers"
              accept=".blb,.bin,.hex,.fw"
              :showUploadList="false"
              :before-upload="beforeUpload"
              @change="uploadChanged"><a-button :loading="uploading"><a-icon type="upload" />{{ $tt('选择固件') }}</a-button></a-upload>
            <div v-if="form.fileName">{{ form.fileName }}（{{ formatSize(form.fileSize) }}，CRC 0x{{ crcHex }}）</div>
          </a-form-model-item>
          <a-form-model-item label="MD5"><a-input :value="form.fileMd5 || $tt('保存后由服务器计算')" disabled /></a-form-model-item>
          <a-form-model-item :label="$tt('发布状态')"><a-switch v-model="form.published" :checked-children="$tt('发布')" :un-checked-children="$tt('草稿')" /></a-form-model-item>
          <a-form-model-item :label="$tt('白名单')"><a-switch v-model="form.whitelistEnabled" :checked-children="$tt('开启')" :un-checked-children="$tt('关闭')" /><div>{{ form.whitelistEnabled ? $tt('仅白名单账号可检测到已发布的固件；未添加账号时无人可见。') : $tt('所有用户均可检测到已发布的固件。') }}</div></a-form-model-item>
          <a-form-model-item v-show="form.whitelistEnabled" :label="$tt('测试账号')">
            <a-select
              v-model="form.whitelistUserIds"
              mode="multiple"
              show-search
              :filter-option="false"
              :loading="userSearching"
              :not-found-content="userSearching ? $tt('搜索中…') : $tt('请输入手机号搜索，最多显示50个结果')"
              :placeholder="$tt('输入手机号或其中一部分，添加白名单账号')"
              @search="onUserSearch"
              @change="onWhitelistChange">
              <a-select-option v-for="user in whitelistOptions" :key="user.id" :value="user.id">{{ user.mobile }}</a-select-option>
            </a-select>
            <div>{{ $tt('已选择 {p0} 个账号，最多500个；关闭白名单会保留名单。', { p0: form.whitelistUserIds.length }) }}</div>
          </a-form-model-item>
          <a-form-model-item :label="$tt('更新说明')"><a-textarea v-model="form.releaseNotes" :rows="4" /></a-form-model-item>
          <a-form-model-item :wrapper-col="{span:18,offset:6}"><a-button type="primary" :loading="saving" @click="submit">{{ $tt('保存') }}</a-button><a-button style="margin-left:8px" @click="formVisible=false">{{ $tt('取消') }}</a-button></a-form-model-item>
        </a-form-model>
      </a-drawer>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { translateText } from '@/locales/text'

import store from '@/store'
import debounce from 'lodash/debounce'
import { pageFirmware, addFirmware, editFirmware, deleteFirmware, searchFirmwareWhitelistUsers } from '@/api/cio/firmware'

const emptyForm = () => ({ id: null, productModel: 'NovaPort_DUOIII65W2C', vendorId: 'hcm111z', versionName: '', versionCode: undefined, fileName: '', fileUrl: '', fileSize: 0, fileCrc: null, fileMd5: '', releaseNotes: '', published: false, whitelistEnabled: true, whitelistUserIds: [], remark: '' })

export default {
  name: 'CioFirmware',
  data () {
    return {
      loading: false,
      saving: false,
      uploading: false,
      rows: [],
      total: 0,
      selected: [],
      formVisible: false,
      userSearching: false,
      userSearchSeq: 0,
      userSearchResults: [],
      selectedUsers: [],
      query: { productModel: '', vendorId: undefined, versionName: '', pageNum: 1, pageSize: 10 },
      form: emptyForm(),
      headers: { Authorization: 'Bearer ' + store.getters.access_token },
      uploadUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      rules: { productModel: [{ required: true, get message () { return translateText('请输入产品型号') } }], vendorId: [{ required: true, get message () { return translateText('请选择供应商') } }], versionName: [{ required: true, get message () { return translateText('请输入版本名称') } }], versionCode: [{ required: true, get message () { return translateText('请输入版本号') } }], fileUrl: [{ required: true, get message () { return translateText('请上传固件文件') } }] },
      columns: [
        { get title () { return translateText('产品型号') }, dataIndex: 'productModel' }, { get title () { return translateText('供应商') }, dataIndex: 'vendorId' }, { get title () { return translateText('版本') }, dataIndex: 'versionName' }, { get title () { return translateText('版本号') }, dataIndex: 'versionCode' },
        { get title () { return translateText('大小') }, dataIndex: 'fileSize', scopedSlots: { customRender: 'fileSize' } }, { get title () { return translateText('状态') }, dataIndex: 'published', scopedSlots: { customRender: 'published' } },
        { title: 'MD5', dataIndex: 'fileMd5' },
        { get title () { return translateText('可见范围') }, dataIndex: 'whitelistEnabled', scopedSlots: { customRender: 'whitelist' } },
        { get title () { return translateText('文件') }, dataIndex: 'fileUrl', scopedSlots: { customRender: 'fileUrl' } }, { get title () { return translateText('操作') }, scopedSlots: { customRender: 'operation' }, width: 120 }
      ]
    }
  },
  computed: {
    crcHex () { return (this.form.fileCrc == null ? 0 : this.form.fileCrc).toString(16).padStart(4, '0').toUpperCase() },
    whitelistOptions () {
      const users = new Map()
      this.selectedUsers.concat(this.userSearchResults).forEach(user => users.set(user.id, user))
      return Array.from(users.values())
    }
  },
  created () {
    this.debouncedUserSearch = debounce(this.searchUsers, 300)
    this.load()
  },
  beforeDestroy () { this.debouncedUserSearch.cancel(); this.userSearchSeq++ },
  methods: {
    resolveFirmwareUrl (fileUrl) {
      if (!fileUrl) return '#'
      const marker = '/local/file/'
      const markerIndex = fileUrl.indexOf(marker)
      if (markerIndex < 0) return fileUrl
      const apiBase = (process.env.VUE_APP_BASE_API || '').replace(/\/$/, '')
      return apiBase + marker + fileUrl.substring(markerIndex + marker.length)
    },
    load () { this.loading = true; pageFirmware(this.query).then(r => { this.rows = r.data.records; this.total = r.data.total }).finally(() => { this.loading = false }) },
    reset () { this.query = { productModel: '', vendorId: undefined, versionName: '', pageNum: 1, pageSize: 10 }; this.load() },
    pageChange (page, size) { this.query.pageNum = page; this.query.pageSize = size; this.load() },
    openForm (row) {
      this.debouncedUserSearch.cancel()
      this.userSearchSeq++
      this.userSearching = false
      this.userSearchResults = []
      this.selectedUsers = (row && row.whitelistUsers ? row.whitelistUsers : []).map(user => ({ ...user, id: String(user.id) }))
      this.form = row ? { ...row, whitelistEnabled: row.whitelistEnabled !== false, whitelistUserIds: this.selectedUsers.map(user => user.id) } : emptyForm()
      this.formVisible = true
      this.$nextTick(() => this.$refs.firmwareForm && this.$refs.firmwareForm.clearValidate())
    },
    onWhitelistChange (values) {
      const selected = new Set(values)
      this.selectedUsers = this.whitelistOptions.filter(user => selected.has(user.id))
    },
    onUserSearch (mobile) {
      this.userSearchSeq++
      this.userSearching = !!mobile.trim()
      this.debouncedUserSearch.cancel()
      if (!mobile.trim()) { this.userSearchResults = []; return }
      this.debouncedUserSearch(mobile.trim(), this.userSearchSeq)
    },
    searchUsers (mobile, sequence) {
      searchFirmwareWhitelistUsers(mobile).then(response => {
        if (sequence !== this.userSearchSeq) return
        // 保留已选择的标签，继续搜索其他手机号时不丢失。
        const selected = new Set(this.form.whitelistUserIds)
        this.selectedUsers = this.whitelistOptions.filter(user => selected.has(user.id))
        this.userSearchResults = (response.data || []).map(user => ({ ...user, id: String(user.id) }))
      }).catch(() => {
        if (sequence === this.userSearchSeq) this.userSearchResults = []
      }).finally(() => { if (sequence === this.userSearchSeq) this.userSearching = false })
    },
    beforeUpload (file) { this.form.whitelistEnabled = true; this.form.fileMd5 = ''; this.form.fileUrl = ''; this.form.fileName = file.name; this.form.fileSize = file.size; file.arrayBuffer().then(buffer => { this.form.fileCrc = this.crc16(new Uint8Array(buffer)) }); return true },
    uploadChanged (info) {
      this.uploading = info.file.status === 'uploading'
      if (info.file.status === 'done') {
        const response = info.file.response || {}
        this.uploading = false
        if (response.success === true && response.data) {
          this.form.fileUrl = response.data
          this.$nextTick(() => this.$refs.firmwareForm && this.$refs.firmwareForm.clearValidate('fileUrl'))
          this.$message.success(translateText('固件上传成功'))
        } else {
          this.form.fileUrl = ''
          this.$message.error(response.message || translateText('固件上传失败'))
        }
      } else if (info.file.status === 'error') {
        this.uploading = false
        this.form.fileUrl = ''
        this.$message.error(translateText('固件上传失败'))
      }
    },
    crc16 (bytes) { let crc = 0xFFFF; bytes.forEach(value => { crc ^= value; for (let i = 0; i < 8; i++) crc = (crc & 1) ? ((crc >> 1) ^ 0xA001) : (crc >> 1) }); return crc & 0xFFFF },
    submit () { this.$refs.firmwareForm.validate(valid => { if (!valid || this.uploading) return; this.saving = true; const request = this.form.id ? editFirmware : addFirmware; request(this.form).then(() => { this.$message.success(translateText('保存成功')); this.formVisible = false; this.load() }).finally(() => { this.saving = false }) }) },
    remove (id) { const ids = id ? [id] : this.selected; deleteFirmware(ids).then(() => { this.$message.success(translateText('删除成功')); this.selected = []; this.load() }) },
    formatSize (size) { if (!size) return '0 B'; if (size < 1024) return size + ' B'; if (size < 1048576) return (size / 1024).toFixed(1) + ' KB'; return (size / 1048576).toFixed(1) + ' MB' }
  }
}
</script>
